"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UINumberInput = _interopRequireDefault(require("./UINumberInput"));

var _UICurrencyInput = _interopRequireDefault(require("./UICurrencyInput"));

var _UIButtonGroup = _interopRequireDefault(require("../button/UIButtonGroup"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _colors = require("HubStyleTokens/colors");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Functions = require("../core/Functions");

var _classnames = _interopRequireDefault(require("classnames"));

var _Dom = require("../utils/Dom");

var _DomEvents = require("../utils/DomEvents");

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _decorators = require("../utils/propTypes/decorators");

var getBaseValue = function getBaseValue(value, placeholderValue) {
  return value != null ? value : placeholderValue;
};

var isIncrementDisabled = function isIncrementDisabled(stepSize, baseValue, max, disabled) {
  if (disabled) return true;
  if (max == null) return false;
  return !(baseValue + stepSize <= max);
};

var isDecrementDisabled = function isDecrementDisabled(stepSize, baseValue, min, disabled) {
  if (disabled) return true;
  if (min == null) return false;
  return !(baseValue - stepSize >= min);
};

var UIStepperInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIStepperInput, _Component);

  function UIStepperInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIStepperInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIStepperInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleStep = function (step) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          inputRef = _this$props.inputRef,
          max = _this$props.max,
          min = _this$props.min,
          onChange = _this$props.onChange,
          onStep = _this$props.onStep,
          placeholderValue = _this$props.placeholderValue,
          readOnly = _this$props.readOnly,
          value = _this$props.value;
      if (readOnly || disabled) return;
      if (inputRef.current) inputRef.current.focus();
      var newValue = getBaseValue(value, placeholderValue) + step;
      var fencedMin = min == null ? newValue : Math.max(newValue, min);
      var fencedValue = max == null ? fencedMin : Math.min(fencedMin, max); // "15 digits of precision ought to be enough for anyone" --Bill Gates

      var roundedValue = +parseFloat(fencedValue).toPrecision(15);
      onChange((0, _SyntheticEvent.default)(roundedValue));
      (0, _Functions.callIfPossible)(onStep, (0, _SyntheticEvent.default)(roundedValue));
    };

    _this.increment = function () {
      if (_this._freeze) return;
      var stepSize = _this.props.stepSize;

      _this.handleStep(stepSize);
    };

    _this.decrement = function () {
      if (_this._freeze) return;
      var stepSize = _this.props.stepSize;

      _this.handleStep(-stepSize);
    };

    _this.handleUpArrowMouseDown = function (evt) {
      if ((0, _DomEvents.isLeftClick)(evt)) {
        _this.startMouseHold('increment');
      }
    };

    _this.handleDownArrowMouseDown = function (evt) {
      if ((0, _DomEvents.isLeftClick)(evt)) {
        _this.startMouseHold('decrement');
      }
    };

    _this.handleArrowMouseUp = function () {
      // Prevent click event from triggering an extra increment/decrement after click-and-hold
      if (_this._repeatHandle && _this._repeatHandle.count >= 1) {
        _this._freeze = true;
        setTimeout(function () {
          _this._freeze = 0;
        }, 0);
      }

      _this._repeatHandle = null;
    };

    _this.handleKeyDown = function (evt) {
      var onKeyDown = _this.props.onKeyDown;
      var key = evt.key;

      if (key === 'ArrowUp') {
        evt.preventDefault();

        _this.increment();
      } else if (key === 'ArrowDown') {
        evt.preventDefault();

        _this.decrement();
      }

      (0, _Functions.callIfPossible)(onKeyDown, evt);
    };

    return _this;
  }

  (0, _createClass2.default)(UIStepperInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._repeatHandle != null) {
        this._repeatHandle.stop();
      }
    }
  }, {
    key: "startMouseHold",
    value: function startMouseHold(action) {
      this._repeatHandle = (0, _Dom.repeatUntilEventOnElement)(this[action], 100, document.documentElement, ['mouseup']);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          currency = _this$props2.currency,
          disabled = _this$props2.disabled,
          disabledMaxButtonTooltip = _this$props2.disabledMaxButtonTooltip,
          disabledMaxButtonTooltipProps = _this$props2.disabledMaxButtonTooltipProps,
          disabledMinButtonTooltip = _this$props2.disabledMinButtonTooltip,
          disabledMinButtonTooltipProps = _this$props2.disabledMinButtonTooltipProps,
          inputClassName = _this$props2.inputClassName,
          max = _this$props2.max,
          min = _this$props2.min,
          placeholderValue = _this$props2.placeholderValue,
          readOnly = _this$props2.readOnly,
          stepSize = _this$props2.stepSize,
          value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "currency", "disabled", "disabledMaxButtonTooltip", "disabledMaxButtonTooltipProps", "disabledMinButtonTooltip", "disabledMinButtonTooltipProps", "inputClassName", "max", "min", "placeholderValue", "readOnly", "stepSize", "value"]);
      var classes = (0, _classnames.default)('private-stepper-input', className);
      var inputClasses = (0, _classnames.default)('private-stepper-input--input', inputClassName);
      var baseValue = getBaseValue(value, placeholderValue);
      var incrementDisabled = isIncrementDisabled(stepSize, baseValue, max, disabled);
      var decrementDisabled = isDecrementDisabled(stepSize, baseValue, min, disabled);
      var Input = currency ? _UICurrencyInput.default : _UINumberInput.default;
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(Input, (0, _extends2.default)({}, rest, {
        "aria-valuemax": max,
        "aria-valuemin": min,
        "aria-valuenow": value,
        currency: currency,
        disabled: disabled,
        className: inputClasses,
        max: max,
        min: min,
        onKeyDown: this.handleKeyDown,
        readOnly: readOnly,
        role: "spinbutton",
        value: value
      })), readOnly ? null : _react.default.createElement(_UIButtonGroup.default, {
        className: "private-stepper-input--buttons",
        orientation: "vertical"
      }, _react.default.createElement(_UITooltip.default, (0, _extends2.default)({
        autoPlacement: "vert",
        placement: "top left"
      }, disabledMaxButtonTooltipProps, {
        title: disabledMaxButtonTooltip,
        disabled: !incrementDisabled
      }), _react.default.createElement(_UIButton.default, {
        "aria-hidden": true,
        disabled: incrementDisabled,
        onClick: this.increment,
        onMouseDown: this.handleUpArrowMouseDown,
        onMouseUp: this.handleArrowMouseUp,
        "data-action": "increment",
        use: "tertiary-light",
        size: "sm",
        tabIndex: -1
      }, _react.default.createElement(_UIIcon.default, {
        name: "up",
        color: !incrementDisabled ? _colors.CALYPSO : null
      }))), _react.default.createElement(_UITooltip.default, (0, _extends2.default)({
        autoPlacement: "vert",
        placement: "top left"
      }, disabledMinButtonTooltipProps, {
        title: disabledMinButtonTooltip,
        disabled: !decrementDisabled
      }), _react.default.createElement(_UIButton.default, {
        "aria-hidden": true,
        disabled: decrementDisabled,
        onClick: this.decrement,
        onMouseDown: this.handleDownArrowMouseDown,
        onMouseUp: this.handleArrowMouseUp,
        "data-action": "decrement",
        use: "tertiary-light",
        tabIndex: -1,
        size: "sm"
      }, _react.default.createElement(_UIIcon.default, {
        name: "down",
        color: !decrementDisabled ? _colors.CALYPSO : null
      })))));
    }
  }]);
  return UIStepperInput;
}(_react.Component);

UIStepperInput.propTypes = (0, _extends2.default)({}, _UINumberInput.default.propTypes, {
  disabledMaxButtonTooltip: _propTypes.default.node,
  disabledMinButtonTooltip: _propTypes.default.node,
  disabledMaxButtonTooltipProps: _propTypes.default.object,
  disabledMinButtonTooltipProps: _propTypes.default.object,
  placeholderValue: (0, _decorators.hidden)(_propTypes.default.number.isRequired),
  value: _propTypes.default.number,
  stepSize: _propTypes.default.number,
  onChange: _propTypes.default.func.isRequired,
  onStep: _propTypes.default.func,
  inputClassName: _propTypes.default.string
});
UIStepperInput.defaultProps = (0, _extends2.default)({}, _UINumberInput.default.defaultProps, {
  disabledMaxButtonTooltipProps: {},
  disabledMinButtonTooltipProps: {},
  placeholderValue: 0,
  stepSize: 1
});
UIStepperInput.displayName = 'UIStepperInput';

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UIStepperInput));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/input/UIStepperInput.js
// module id = 460
// module chunks = 5 6